import React, { useEffect, useState } from "react";
import Button from 'antd/lib/button';
import Checkbox from 'antd/lib/checkbox';
import DatePicker from 'antd/lib/date-picker';
import Drawer from 'antd/lib/drawer';
import Icon from 'antd/lib/icon';
import Input from 'antd/lib/input';
import Select from 'antd/lib/select';
import { useDispatch, useSelector } from "react-redux";
import { MOBILE_BREAK_POINT } from "src/globals";
import SearchTagsInput from "src/components/common/SearchTagsInput";
import { getPorts } from "src/api/containerTracking";
import { shipmentSetFilter } from "src/actions/shipmentExecutionActions";
import { getFFDimensions } from "src/selectors/importsFilter";
import useCarriers from "src/hooks/fields/useCarriers";
import useAddress from "src/hooks/fields/useAddress";
import Loader from "src/components/common/Loader";
import moment from "moment";
import GenericHoc from "src/components/hoc/GenericHoc";
import { HocOptions } from 'src/components/hoc/GenericHoc.types';
import useIncoterm from "src/hooks/fields/useIncoterm";
import { commonStyleSheet } from "src/Library/CommonStyles";
import { searchCustomer, searchMyTaskNameList } from "src/api/shipmentExecution";
import { siInttraStatusFilterList } from "./SE.utils";
import { searchProduct } from "../masters/Product/Product.api";
import { myTaskListStatus } from "./SE.constants";
import { Tooltip, Form } from "antd";
import { fetchAllTeams, fetchAllUsersInTeam} from "src/api/teams";
import { fetchAllUsersOfCurrentOrg } from "src/api/users";

const styles = () => ({
  [`@media (max-width: ${MOBILE_BREAK_POINT}px)`]: {
    mainDiv: {
      display: 'inline-block',
    },
  },
  customDrawer: {
    '& .ant-drawer-body': {
      maxHeight: 'calc(100vh - 120px) !important',
      overflow: 'auto !important'
    }
  },
  mainDiv: {
    height: '100%',
  },
  childDiv: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: 10,
  },
  leftElement: {
    width: 70,
    marginRight: '10px',
    fontSize: 12,
    fontWeight: 600,
  },
  rightElement: {
    width: '390px',
    fontSize: 12,
  },
  hrElement: {
    border: 'none',
    borderTop: '1px double #EDEDED',
    color: '#EDEDED',
    marginBottom: 15,
  },
  contentDiv: {
    padding: '5px 0px',
    ...commonStyleSheet.flexRow,
    justifyContent: 'space-between',
    '& .ant-drawer-header': {
      height: 56,
    },
  },
  ffType: {
    backgroundColor: '#FFE7D5',
    border: '1px solid #FFC59A',
    padding: '0px 4px',
    marginLeft: '5px',
    fontSize: '10px',
    borderRadius: '2px',
  },
  groupType: {
    backgroundColor: '#EDE3FC',
    border: '1px solid #A082CE',
    padding: '0px 4px',
    marginLeft: '5px',
    fontSize: '10px',
    borderRadius: '2px',
  }
});
const FormItem = Form.Item;
interface SEMoreFiltersDrawerProps {
  classes: {
    [X in keyof ReturnType<typeof styles>]: string
  };
  form: any;
  visible: boolean;
  handleClose: () => void;
  type: string;
  handleApply: () => void;
  handleResetMoreFilters: () => void;
  orgID: string;
  role: string;
}

const SEMoreFiltersDrawer = (props: SEMoreFiltersDrawerProps) => {
  const { classes, visible, handleClose, type, form, handleApply, handleResetMoreFilters,orgID } = props;

  const [myTaskNameList, setMyTaskNameList] = useState<string[]>([]);
  const [myTaskStatusList, setMyTaskStatusList] = useState<{key: string, label: string}[]>([]);
  const [sourcePortOptions, setSourcePortOptions] = useState([]);
  const [fullUserList, setFullUserList] = useState<{key: string, label: string}[]>([]);
  const [userOptions, setUserOptions] = useState<{key: string, label: string}[]>([]);
  const [fullTeamList, setFullTeamList] = useState<{key: string, label: string}[]>([]);
  const [teamOptions, setTeamOptions] = useState<{key: string, label: string}[]>([]);
  const [teamIdforUser, setTeamIdforUser] = useState<string[]>([]);
  const [searching, setSearching] = useState(false);
  const [searchItems, setSearchItems] = useState<{ org2Id: string; name: string }[]>([]);
  const [ isLoading, setIsLoading ] = useState(false);
  const [products, setProducts] = useState<{
    key: string,
    labe: string,
  }[]>([]);
  const [supplierOptions, setSupplierOptions] = useState<{ key: string; label: string }[]>([]);

  const filters = useSelector<any, any>(state => state.shipmentExecutionReducer.selectedFilters);
  const dispatch = useDispatch();
  const ffDimensions = useSelector<any, any>(state => getFFDimensions(state.masterData));
  const ffGroups = useSelector<any, any>(state => state.masterData.dimensionData.FF_GROUPS);

  const carrier = useCarriers({
    form,
    disabled: false,
    visible: true,
    key: "carrierCode",
    label: "Carrier",
    placeholder: "Select Carrier",
  }, 'ALL');
  
  const plant = useAddress({
    form,
    disabled: false,
    visible: true,
    key: "plantId",
    label: "Plant",
    placeholder: "Select Plant",
  }, undefined, 'PLANT');

  const incoterm = useIncoterm(
    {
      props: {
        form,
        disabled: false,
        visible: true,
        key: "incoterm",
        label: "Incoterm",
        placeholder: "Select Incoterm",
      },
      defaultMode: "FCL",
      showAll: true,
    }
  );
  
  const setInitialData = async () => {
    const response = await searchCustomer({
      type: 'CUSTOMER',
      queryString: '',
    });
    if (response.isSuccess) {
      const customerData = response.data ? response.data : [];
      setSearchItems(customerData);
    }
    setIsLoading(false);
  }

  const fetchAllMyTaskList = async () => {
    const response = await searchMyTaskNameList();
    if (response.isSuccess) {
      const myTaskStatusList = Object.keys(response.data?.taskStatus || {}).map(status => ({key: status, label: response?.data?.taskStatus?.[status]}));
      const myTaskAllList = response.data?.taskNames;
      setMyTaskNameList(myTaskAllList || []);
      setMyTaskStatusList(myTaskStatusList);
    }
  }
  useEffect(() => {
    if (teamIdforUser) {
      setUserList();
    }
  }, [teamIdforUser]);
  useEffect(() => {
    const initializeData = async () => {
      setIsLoading(true);
      await setInitialData();
      await setTeamList();  // Wait for team list to be set
      await setUserList();  // Then set user list
      await fetchAllMyTaskList();
      carrier.setValue(filters.carrierCodeList);
      plant.setValue(filters.plantIdList);
      incoterm.setValue(filters.incotermList);
      setIsLoading(false);
    };
    
    initializeData();
  }, []);
  useEffect(() => {
    dispatch(shipmentSetFilter({
      plantIdList: plant.value,
    }));
  }, [plant.value])

  useEffect(() => {
    dispatch(shipmentSetFilter({
      carrierCodeList: carrier.value,
    }));
  }, [carrier.value])

  useEffect(() => {
    dispatch(shipmentSetFilter({
      incotermList: incoterm.value,
    }));
  }, [incoterm.value])
  
  const searchForSourcePort = async (queryString) => {
    const response = await getPorts({ queryString, type: 'ALL' });
    if (response.isSuccess) {
        const portData = response.data.map(el => ({
            key: el.code,
            label: el.name.concat('[', `${el.code}`, ']'),
        }));
        setSourcePortOptions(portData);
    }
  }
  const setUserList = async () => {
    let allUsers: any[] = []; // Explicitly type as any array
    
    if (props.role === "MEMBER" && Array.isArray(teamIdforUser) && teamIdforUser.length > 0) {
      // Fetch users from all teams
      const userPromises = teamIdforUser.map(teamId => fetchAllUsersInTeam(teamId));
      const responses = await Promise.all(userPromises);
      
      // Combine all users from all teams
      responses.forEach(response => {
        if (response?.isSuccess && response?.data?.[0]?.users) {
          allUsers = [...allUsers, ...response.data[0].users];
        }
      });
      
      // Remove duplicates based on user ID
      const uniqueUsersMap = new Map<string, any>();
      allUsers.forEach(user => {
        if (user?.id && !uniqueUsersMap.has(user.id)) {
          uniqueUsersMap.set(user.id, user);
        }
      });
      
      // Convert back to array
      const uniqueUsers = Array.from(uniqueUsersMap.values());
      
      const userData = uniqueUsers.map(user => ({
        key: user.id,
        label: user.name,
      }));
      
      setFullUserList(userData);
      setUserOptions(userData);
    } else {
      // Fallback to fetching all users from current org
      const response = await fetchAllUsersOfCurrentOrg();
      if (response?.isSuccess) {
        const shipmentOwners = response?.data || [];
        const userData = shipmentOwners.map(user => ({
          key: user.id,
          label: user.name,
        }));
        setFullUserList(userData);
        setUserOptions(userData);
      }
    }
  };
  
  
  const searchForUser = async (searchName) => {
    if (!searchName) {
      // No search term? Show the full list.
      setUserOptions(fullUserList);
    } else {
      const filteredUsers = fullUserList.filter(user =>
        user?.label.toLowerCase().includes(searchName.toLowerCase())
      );
      setUserOptions(filteredUsers);
    }
  };
  const setTeamList = async () => {
    const response = await fetchAllTeams({ name: '' });
    if (response?.isSuccess) {
      const teams = response?.data || [];
      const teamData = teams.map(team => ({
        key: team?.id,
        label: team?.name,
      }));
      setFullTeamList(teamData);
      setTeamOptions(teamData);
      
      // Store all team IDs for user fetching
      const allTeamIds = teams.map(team => team?.id);
      setTeamIdforUser(allTeamIds); // Now storing array of IDs
    }
  };
  const searchForTeam = async (searchName) => {
    if (!searchName) {
      // No search term? Show the full list.
      setTeamOptions(fullTeamList);
    } else {
      const filteredTeams = fullTeamList?.filter(team =>
        team?.label.toLowerCase().includes(searchName.toLowerCase())
      );
      setTeamOptions(filteredTeams);
    }
  };
  
  let searchTimer: any = null;
  const handleSearchCustomer = (value) => {
    if (searchTimer) {
      clearTimeout(searchTimer);
      searchTimer = null;
    }
    setSearching(true);
    searchTimer = setTimeout(async () => {
      const response = await searchCustomer({ type: 'CUSTOMER', queryString: value });
      setSearching(false);
      if (response.isSuccess) {
        const customerData = response.data ? response.data : [];
        setSearchItems(customerData);
      }
    }, 300);
  }

  const handleSearchSuppliers = (value) => {
    if (searchTimer) {
      clearTimeout(searchTimer);
      searchTimer = null;
    }
    setSearching(true);
    searchTimer = setTimeout(async () => {
      const response = await searchCustomer({ type: 'SUPPLIER', queryString: value });
      setSearching(false);
      if (response.isSuccess) {
        const supplierData = (response.data ? response.data : [])?.map(item => ({key: item.org2Id, label: item.name}));
        setSupplierOptions(supplierData);
      }
    }, 300);
  }

  const handleDateChange = (val) => {
    dispatch(shipmentSetFilter({
        dateFilter: val,
    }));
  }

  async function searchProductsHelper(searchQuery: string) {
    const response = await searchProduct({ searchQuery, status: 'ACTIVE' });
    setProducts((response?.data || []).map(item => ({
        key: item.id,
        label: item.internalName,
    })),
    );
  }


  const handleDateRange = (val) => {
    if (!val.length) {
      dispatch(shipmentSetFilter({
        dateRangeFilter: undefined,
        dateRange: val,
      }));
    } else {
      dispatch(shipmentSetFilter({
        dateRange: val,
      }));
      const date: any = { startDate: moment(), endDate: moment() };
      date.startDate = moment(val[0]).utc().startOf('day').valueOf();
      date.endDate = moment(val[1]).utc().endOf('day').valueOf();
      dispatch(shipmentSetFilter({
        dateRangeFilter: date,
      }));
    }
  }

  const renderOriginPortFilter = () => {
    return (
        <div className={classes.childDiv} >
            <span className={classes.leftElement}>Origin</span>
            <SearchTagsInput
                className={classes.rightElement}
                mode="multiple" 
                placeholder="Select Origin"
                // style={{ minWidth: '30%', maxWidth: '60%' }}
                dropdownStyle={{ maxWidth: '240px' }}
                options={sourcePortOptions}
                value={filters.polList}
                onChange={(selectedFilters) => {
                    dispatch(shipmentSetFilter({
                        polList: selectedFilters,
                    }));
                }}
                searchFunction={e => searchForSourcePort(e)}
                size={'default'} 
            />
        </div>
    )
  }
  const renderUserFilter = () => {
    return (
      <div className={classes.childDiv} >
          <span className={classes.leftElement}>Created By</span>
          <SearchTagsInput
              className={classes.rightElement}
              mode="multiple" 
              placeholder="Select User"
              // style={{ minWidth: '30%', maxWidth: '60%' }}
              dropdownStyle={{ maxWidth: '240px' }}
              options={userOptions}
              value={filters.userList}
              onChange={(selectedFilters) => {
                  dispatch(shipmentSetFilter({
                      userList: selectedFilters,
                  }));
              }}
              notFoundContent={'Not Found'}
              searchFunction={e => searchForUser(e)}
              size={'default'} 
          />
      </div>
  )
  }
  const renderTeamFilter = () => {
    return (
      <div className={classes.childDiv} >
          <span className={classes.leftElement}>Team</span>
          <SearchTagsInput
              className={classes.rightElement}
              mode="multiple" 
              placeholder="Select Team"
              // style={{ minWidth: '30%', maxWidth: '60%' }}
              dropdownStyle={{ maxWidth: '240px' }}
              options={teamOptions}
              value={filters.teamList}
              onChange={(selectedFilters) => {
                  dispatch(shipmentSetFilter({
                      teamList: selectedFilters,
                  }));
              }}
              notFoundContent={'Not Found'}
              searchFunction={e => searchForTeam(e)}
              size={'default'} 
          />
      </div>
  )
  }

  const renderDestinationPortFilter = () => {
    return (
        <div className={classes.childDiv} >
        <span className={classes.leftElement}>Destination </span>
        <SearchTagsInput mode="multiple" placeholder="Select Destination"
            // style={{ minWidth: '30%', maxWidth: '60%' }}
            className={classes.rightElement}
            dropdownStyle={{ maxWidth: '240px' }}
            options={sourcePortOptions}
            value={filters.podList}
            onChange={(selectedFilters) => {
                dispatch(shipmentSetFilter({
                    podList: selectedFilters,
                }));
            }}
            searchFunction={e => searchForSourcePort(e)}
            size={'default'} />
        </div>
    )
  }
const renderFFandCHAFilterForVender = () => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
      <div className={classes.childDiv}>
        <Checkbox.Group
          options={[{ label: "FF", value: orgID }]}
          value={filters.ffIdList}
          onChange={(selectedFilters) => {
            dispatch(shipmentSetFilter({ ffIdList: selectedFilters }));
          }}
        />
      </div>

      <div className={classes.childDiv}>
        <Checkbox.Group
          options={[{ label: "CHA", value: orgID }]}
          value={filters.chaIdList}
          onChange={(selectedFilters) => {
            dispatch(shipmentSetFilter({ chaIdList: selectedFilters }));
          }}
        />
      </div>

      <div className={classes.childDiv}>
        <Checkbox.Group
          options={[{ label: "Tranporter", value: orgID }]}
          value={filters.transporterIdList} // assuming your filter key is 'tranporterList'
          onChange={(selectedFilters) => {
            dispatch(shipmentSetFilter({ transporterIdList: selectedFilters }));
          }}
        />
      </div>
    </div>
  );
}
  const renderFFFilter = () => {
    const ffAndGroupsList = [...ffDimensions.map((ff) => ({...ff, isGroup: false})), ...ffGroups.map((ffGroup) => ({key: ffGroup?.id, label: ffGroup?.name, isGroup: true}))];
    return (
        <div className={classes.childDiv} >
            <span className={classes.leftElement}>FF</span>
            <Select mode="multiple" placeholder="Select FF"
                // style={{ minWidth: '30%', maxWidth: '60%' }}
                className={classes.rightElement}
                dropdownStyle={{ maxWidth: '240px' }}
                value={[...(filters?.ffIdList || []), ...(filters?.ffGroupIdList || [])]}
                onChange={(selectedFilters) => {
                  const selectedFF = selectedFilters.filter((item) => ffDimensions.find((ff) => ff.key === item));
                  const selectedFFGroups = selectedFilters.filter((item) => ffGroups.find((ff) => ff.id === item));
                  dispatch(shipmentSetFilter({
                    ffIdList: selectedFF,
                    ffGroupIdList: selectedFFGroups,
                  }));
                }}
                size={'default'}>
                {ffAndGroupsList.map((item) => {
                    return <Select.Option key={item.key}>
                      <div style={{display:'flex', justifyContent: 'space-between'}}>
                      <span>{item.label}</span>
                      <span className={item.isGroup ? classes.groupType : classes.ffType}>{item.isGroup ? 'Group' : 'FF'}</span>
                      </div>
                    </Select.Option>;
                })}
            </Select>
        </div>
    )
  }
const renderTransporterFilter = () => {
  return (
    <div className={classes.childDiv} >
        <span className={classes.leftElement}>Transporter</span>
        <Select mode="multiple" placeholder="Select Transporter"
            // style={{ minWidth: '30%', maxWidth: '60%' }}
            className={classes.rightElement}
            dropdownStyle={{ maxWidth: '240px' }}
            value={filters.transporterIdList}
            onChange={(selectedFilters) => {
                dispatch(shipmentSetFilter({
                    transporterIdList: selectedFilters,
                }));
            }}
            size={'default'}>
            {ffDimensions.map((item) => {
                return <Select.Option key={item.key}>{item.label}</Select.Option>;
            })}
        </Select>
    </div>
  )
}
  const renderCHAFilter = () => {
    return (
        <div className={classes.childDiv} >
        <span className={classes.leftElement}>CHA</span>
        <Select mode="multiple" placeholder="Select CHA"
            // style={{ minWidth: '30%', maxWidth: '60%' }}
            className={classes.rightElement}
            dropdownStyle={{ maxWidth: '240px' }}
            value={filters.chaIdList}
            onChange={(selectedFilters) => {
                dispatch(shipmentSetFilter({
                    chaIdList: selectedFilters,
                }));
            }}
            size={'default'}>
            {ffDimensions.map((item) => {
                return <Select.Option key={item.key}>{item.label}</Select.Option>;
            })}
        </Select>
    </div>   
    )
  }

  const renderCustomerFilter = () => {
    return (
        <div className={classes.childDiv} >
        <span className={classes.leftElement}>Customer</span>
        <Select mode="multiple" placeholder="Select Customer"
            // style={{ minWidth: '30%', maxWidth: '60%' }}
            className={classes.rightElement}
            value={filters.customerIdList}
            onSearch={handleSearchCustomer}
            onFocus={() => handleSearchCustomer('')}
            onChange={(selectedFilters) => {
                dispatch(shipmentSetFilter({
                    customerIdList: selectedFilters,
                }));
            }}
            size={'default'}
            filterOption={(inputValue, option) => true}
            notFoundContent={searching ? <div style={{ display: 'flex',
            justifyContent: 'center', alignItems: 'center' }}>
            <Icon type="loading" style={{ fontSize: 40 }}
            spin />
        </div> : 'Not Found'}
        dropdownRender={menu => <div style={{
        border: '1px solid rgba(0, 0, 0, 0.15)' }}>
        {searching ? menu : <React.Fragment>
            {menu}
        </React.Fragment>}
        </div>}>
        {searching ? null : (
        (searchItems && searchItems.length) ?
        searchItems.map((item) => <Select.Option key={item.org2Id}>
            {item.name}
            </Select.Option>) : null
        )}
        </Select>
    </div>
    )
  }

  const renderSupplierFilter = () => {
    return (
        <div className={classes.childDiv} >
        <span className={classes.leftElement}>Supplier </span>
        <SearchTagsInput mode="multiple" placeholder="Select Supplier"
            // style={{ minWidth: '30%', maxWidth: '60%' }}
            className={classes.rightElement}
            dropdownStyle={{ maxWidth: '240px' }}
            options={supplierOptions}
            value={filters.supplierIdList}
            onChange={(selectedFilters) => {
                dispatch(shipmentSetFilter({
                    supplierIdList: selectedFilters,
                }));
            }}
            searchFunction={e => handleSearchSuppliers(e)}
            size={'default'} />
        </div>
    )
  }

  const renderCarrierFilter = () => {
    return <div className={classes.childDiv}>
      <span className={classes.leftElement} style={{ marginTop: -25 }}>{carrier.label}</span>
      {carrier.decorator(<Select mode="multiple"
        // style={{ minWidth: '30%', maxWidth: '60%' }}
        className={classes.rightElement}
        size={'default'}>
        </Select>)}
    </div>;
  }

  const renderIncotermFilter = () => {
    return <div className={classes.childDiv}>
      <span className={classes.leftElement} style={{ marginTop: -25 }}>Incoterm</span>
      {incoterm.decorator(<Select mode="multiple" allowClear
        className={classes.rightElement}
         />)}
    </div>;
  };

  const renderPlantFilter = () => {
    return <div className={classes.childDiv} style={{ marginTop: -25 }}>
      <span className={classes.leftElement} style={{ marginTop: -25 }}>Plant</span>
      {plant.decorator(<Select mode="multiple" 
      // placeholder="Select Plant"
        // style={{ minWidth: '30%', maxWidth: '60%' }}
        className={classes.rightElement}
        size={'default'}>
          {/* {(plantOptions?.length) ?
          plantOptions.map((item: any) => <Select.Option key={item.id}>
              {item.name}
            </Select.Option>) : null
        } */}
        </Select>)}
    </div>;
  }

  const renderProductFilter = () => {
    return <div className={classes.childDiv} style={{ marginTop: -25 }}>
      <span className={classes.leftElement} style={{ marginTop: -44 }} >Products</span>
        <FormItem
            className={classes.rightElement}
            colon={false}
        >
            {form.getFieldDecorator('productKeyList', {
              initialValue: (filters.productKeyList || [])
            })(<SearchTagsInput
                searchFunction={searchProductsHelper}
                placeholder="Products"
                options={products}
                onChange={(val) => {
                  dispatch(shipmentSetFilter({
                    productKeyList: val
                  }))
                }}
                style={{
                  width: "100%",
                  overflow: 'hidden',
                }}
                mode="multiple"
            />)}
        </FormItem>
    </div>
  };

  const renderPONumberListFilter = () => {
    return <div className={classes.childDiv} style={{ marginTop: -37 }}>
      <span className={classes.leftElement} style={{ marginTop: -37 }}>PO Numbers</span>
      <FormItem
        className={classes.rightElement}
        colon={false}
      >
        {form.getFieldDecorator("poNumberList", {
          initialValue: filters.poNumberList || []
        })(<Select
          style={{
            width: "100%",
            overflow: 'hidden',
          }}
          mode="tags"
          placeholder={"PO Numbers"}
          className={classes.input}
          onChange={(val) => {
            dispatch(shipmentSetFilter({
              poNumberList: val
            }))
          }}
          notFoundContent={null}
        />)}
      </FormItem>
    </div>
  };

  const renderTrackingFilter = () => {
    const trackingOptions = [
      { label: 'Available', value: true },
      { label: 'Not Available', value: false },
    ];
    return <div className={classes.childDiv}>
      <span className={classes.leftElement}>Tracking</span>
      <Checkbox.Group options={trackingOptions}
        value={filters.hasTracking !== undefined ? [filters.hasTracking] : undefined}
        onChange={(checkedValues: boolean[]) => {
          let valueToSet: boolean | undefined;
          if (checkedValues && checkedValues.length) {
            const values = checkedValues.filter(v => v !== filters.hasTracking);
            valueToSet = values[0];
          }
          dispatch(shipmentSetFilter({
            hasTracking: valueToSet,
          }));
        }} />
    </div>;
  }

  const renderDateFilter = () => {
    return (
      <div >
        <div className={classes.leftElement} style={{ marginBottom: 5 }}>Date</div>
        <Input.Group compact style={{ display: 'flex' }}>
          <Select
            style={{ width: '172px' }}
            value={filters.dateFilter}
            onChange={val => handleDateChange(val)}>
            <Select.Option key={'nearestDeadline'}
              data-value={'nearestDeadline'}>Nearest Task Deadline</Select.Option>
            <Select.Option key={'updatedAt'}
              data-value={'updatedAt'}>Last Update</Select.Option>
            <Select.Option key={'createdAt'}
              data-value={'createdAt'}>Creation Date</Select.Option>
          </Select>
          <DatePicker.RangePicker
            value={filters.dateRange}
            onChange={val => handleDateRange(val)}
          />
        </Input.Group>
      </div>
    )
  }

  const handleReset = () => {
    handleResetMoreFilters();
    carrier.setValue([]);
    plant.setValue([]);
    incoterm.setValue([]);
  }

  const renderFooter = () => {
    return (
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e8e8e8',
          padding: '10px 16px',
          textAlign: 'left',
          left: 0,
          background: '#fff',
          borderRadius: '0 0 4px 4px',
          height: 56,
        }}
      >
        <Button onClick={handleApply} type="primary" style={{ marginLeft: 10, marginRight: 20 }}>
          Apply
        </Button>
        <a style={{ color: '#000' }} onClick={handleClose}>
          Cancel
        </a>
      </div>
    );
  };

  const renderLine = () => {
    return <hr className={classes.hrElement} />;
  };

  const renderLineWithTopMargin = () => {
    return <hr className={classes.hrElement} style={{ marginTop: -25 }} />;
  };

  const drawerTitle = () => (
    <div className={classes.contentDiv}>
      <div>
        <Icon type="close" onClick={handleClose} />
        <span style={{ marginLeft: 10, fontSize: 20, fontWeight: 500 }}>More Filters</span>
      </div>
      <div style={{ color: '#DF1D1D', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
        onClick={handleReset}>
        Reset Filter
      </div>
    </div>
  )

  const renderSiInttraStatusFilter = () => {
    return (
      <div className={classes.childDiv} style={{ marginTop: -25 }}>
          <span className={classes.leftElement}>SI INTTRA Status</span>
          <Checkbox.Group
              options={siInttraStatusFilterList}
              value={filters.siInttraStatusList}
              onChange={(checkedValues) => {
                  dispatch(shipmentSetFilter({
                      siInttraStatusList: checkedValues,
                  }));
              }}
          />
      </div>
    );
  }

  const renderMyTaskListFilter = () => {
    return (
      <div className={classes.childDiv}>
        <span className={classes.leftElement}>Task List</span>
        <Select
          showSearch
          allowClear
          mode="default"
          placeholder="Select Task List "
          // style={{ minWidth: '30%', maxWidth: '60%' }}
          className={classes.rightElement}
          dropdownStyle={{ maxWidth: '240px' }}
          value={filters.myTaskNameFilterList}
          onChange={(val) => {
            dispatch(
              shipmentSetFilter({
                myTaskNameFilterList: val,
              })
            );
          }}
          size={'default'}
        >
          {myTaskNameList.map((task) => {
            return (
              <Select.Option key={task} value={task}>
                <Tooltip title={task} placement={'left'}>
                  {task}
                </Tooltip>
              </Select.Option>
            );
          })}
        </Select>
      </div>
    );
  };
  const renderMyTaskListStatusFilter = () => {
    return (
      <div className={classes.childDiv}>
        <span className={classes.leftElement}>Task Status</span>
        <Select
          showSearch
          allowClear
          mode="multiple"
          placeholder="Select Task Status"
          // style={{ minWidth: '30%', maxWidth: '60%' }}
          className={classes.rightElement}
          dropdownStyle={{ maxWidth: '240px' }}
          value={filters.myTaskStatusFilterList}
          onChange={(val) => {
            dispatch(
              shipmentSetFilter({
                myTaskStatusFilterList: val,
              })
            );
          }}
          size={'default'}
        >
          {myTaskStatusList.map((status) => {
            return (
              <Select.Option key={status.key} value={status.key}>
                <Tooltip title={status.label} placement={'left'}>
                  {status.label}
                </Tooltip>
              </Select.Option>
            );
          })}
        </Select>
      </div>
    );
  };

  return <Drawer
    visible={visible}
    closable={false}
    width='519.7px'
    height='650px'
    title={drawerTitle()}
    onClose={handleClose}
    className={classes.customDrawer}>
    
    <div className={classes.mainDiv} >
      <div>
        {isLoading ? <Loader /> : null}
      </div>
      {renderOriginPortFilter()}
      {renderDestinationPortFilter()}

      {renderLine()}
      {type === 'FF' ? (
  renderFFandCHAFilterForVender()
) : (
  <>
    {renderFFFilter()}
    {renderCHAFilter()}
    {renderTransporterFilter()}
  </>
)}
      {type !== "FF" && type !== "VENDOR" && renderCustomerFilter()}
      {type !== "FF" && renderSupplierFilter()}
      {renderUserFilter()}
      {renderTeamFilter()}
      {renderLine()}
      {renderCarrierFilter()}
      {renderPlantFilter()}
      {renderSiInttraStatusFilter()}
      {renderIncotermFilter()}

      {renderProductFilter()}
      {renderPONumberListFilter()}
      {renderLineWithTopMargin()}
      {renderTrackingFilter()}
      
      {renderLine()}
      {renderDateFilter()}
      {renderLine()}
      {renderMyTaskListFilter()}
      {renderMyTaskListStatusFilter()}
      {renderFooter()}
    </div>
  </Drawer>
}
const mapStateToProps = ({ masterData }) => {
  return {
    orgID: masterData?.userData?.organisation_id,
    role : masterData?.userData?.role
  };
};

const options: HocOptions = {
  connectRedux: {
    useRedux: true,
    mapStateToProps,
  },
  connectForm: {
    useForm: true,
  },
  connectJss: {
    useJss: true,
    styleSheet: styles,
  },
};

const SEMoreFiltersDrawerWithHOC = GenericHoc(options)(SEMoreFiltersDrawer);
export default SEMoreFiltersDrawerWithHOC;
